import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../../Common/ies-http-client.service';
import { AppUrl } from '../../../Common/appUrl';

@Injectable()
export class KoalaConfigService {    
    constructor(private _httpClient: IesHttpClient) {
    }

    getKoala(urlParams: any) {
        return this._httpClient.get(AppUrl.getKoala, urlParams);
    }

    //Save, Update Exams
    addKoala(params: any) {
        return this._httpClient.post(AppUrl.addKoala, params);
    }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location/adm-manage-koalaconfig/adm-manage-koalaconfig.service.ts